var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBag3SvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag-3-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.4731 61.8484C16.4718 66.6667 23.9141 66.6667 38.7989 66.6667H41.2029C56.0875 66.6667 63.5299 66.6667 67.5286 61.8484M12.4731 61.8484C8.47428 57.0304 9.84581 49.7154 12.5889 35.0857C14.5397 24.6818 15.515 19.4798 19.218 16.4066M67.5286 61.8484C71.5272 57.0304 70.1559 49.7154 67.4129 35.0857C65.4619 24.6818 64.4865 19.4798 60.7835 16.4066M60.7835 16.4066C57.0805 13.3334 51.7882 13.3334 41.2029 13.3334H38.7989C28.2136 13.3334 22.921 13.3334 19.218 16.4066",
    stroke: "#202020",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M30.5703 26.6666C31.9431 30.5506 35.6473 33.3333 40.0013 33.3333C44.3553 33.3333 48.0596 30.5506 49.4323 26.6666",
    stroke: "#202020",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag3SvgrepoCom1);
export default __webpack_public_path__ + "static/media/bag-3-svgrepo-com 1.5a78561fd992fc6e66a1060ca955725a.svg";
export { ForwardRef as ReactComponent };